import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Dialog,
  DialogContent,
  DialogTitle,
} from 'corso-admin-ui';
import { useCallback, useEffect, useState } from 'react';
import { MediaFull } from './MediaFull';
import { MediaThumbnails } from './MediaThumbnails';
import { MediaItem } from './types';

export function MediaLightbox({
  title,
  items,
  open,
  onOpenChange,
  startIndex = 0,
}: {
  title: string;
  items: MediaItem[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  startIndex?: number;
}) {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(startIndex);

  const onSelect = useCallback((carousel: NonNullable<CarouselApi>) => {
    setCurrent(carousel.selectedScrollSnap());
  }, []);

  useEffect(() => {
    api?.on('init', onSelect);
    api?.on('reInit', onSelect);
    api?.on('select', onSelect);

    return () => {
      api?.off('init', onSelect);
      api?.off('reInit', onSelect);
      api?.off('select', onSelect);
    };
  }, [api, onSelect]);

  const showControls = items.length > 1;

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <DialogContent className="h-screen max-h-full w-screen max-w-full border-none bg-black p-0 shadow-none">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <Carousel
          className="flex flex-col items-center justify-center gap-4"
          setApi={setApi}
          opts={{ startIndex }}
        >
          <div className="flex w-[100vw] items-center justify-center gap-4 p-4">
            {showControls && (
              <CarouselPrevious className="disabled:invisible" />
            )}
            <CarouselContent className="h-[80vh] max-h-full w-[90vw] max-w-full">
              {items.map((item) => (
                <CarouselItem key={item.src}>
                  <MediaFull src={item.src} alt={item.alt} />
                </CarouselItem>
              ))}
            </CarouselContent>
            {showControls && <CarouselNext className="disabled:invisible" />}
          </div>
          {showControls && (
            <div className="p-4">
              <MediaThumbnails
                tone="dark"
                items={items}
                activeIndex={current}
                onSelect={(index) => api?.scrollTo(index)}
              />
            </div>
          )}
        </Carousel>
      </DialogContent>
    </Dialog>
  );
}
